import React from 'react';

import {observer} from 'mobx-react';
import {WebsiteModuleProps} from "../../models/website-module.props";
import {
  NotificationGuideModuleAsync
} from "../../modules/notification-guide-module/components/notification-guide-module.async";

export const WebsiteModuleNotificationGuide = observer(({controller}: WebsiteModuleProps) => {
  const moduleProps = {
    controller,
  }

  return (
      controller.state.appState?.shouldRenderNotificationGuide ? <NotificationGuideModuleAsync {...moduleProps} /> : null
  )
});
